/**
 * Client data model definition
 */

// Default client statuses
export const CLIENT_STATUSES = {
  LEAD: 'Lead',
  CONNECTED_PENDING: 'Connected (Pending)',
  CONNECTED_FOLLOWUP: 'Connected (Follow-Up)',
  REJECTED: 'Rejected',
  NOT_CONNECTED: 'Not Connected',
  CALL_BACK: 'Call Back',
  CLOSED: 'Closed',
};

// Default tag options
export const DEFAULT_TAGS = [
  'Imp',
  'v imp',
  'Amazon',
  'Flipkart',
  'meesho',
  'myntra'
];

// Default client model with all fields
export const DEFAULT_CLIENT = {
  id: '',
  firstName: '',
  lastName: '',
  company: '',
  email: '',
  phone: '',
  alternatePhone: '',
  status: CLIENT_STATUSES.LEAD,
  address: '',
  remarks: '',
  tags: '',
  firstContactDate: '',
  nextFollowUp: '',
  createdAt: '',
  updatedAt: '',
};

// Validation schema for client form
export const validateClient = (client) => {
  const errors = {};
  
  if (!client.firstName.trim()) {
    errors.firstName = 'First name is required';
  }
  
  // Last name is now optional
  
  if (client.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(client.email)) {
    errors.email = 'Invalid email address';
  }
  
  if (client.phone && !/^\+?[\d\s()-]{10,15}$/.test(client.phone)) {
    errors.phone = 'Invalid phone number';
  }
  
  return errors;
};

// Generate sample clients for testing
export const generateSampleClients = (count = 10) => {
  const sampleClients = [];
  const statuses = Object.values(CLIENT_STATUSES);
  
  for (let i = 0; i < count; i++) {
    const now = new Date();
    const id = (Date.now() + i).toString();
    
    sampleClients.push({
      id,
      firstName: `FirstName${i + 1}`,
      lastName: `LastName${i + 1}`,
      company: `Company ${i + 1}`,
      email: `client${i + 1}@example.com`,
      phone: `+1 555-${100 + i}-${1000 + i}`,
      status: statuses[i % statuses.length],
      address: `${1000 + i} Main St`,
      city: 'Anytown',
      state: 'ST',
      zipCode: `${10000 + i}`,
      notes: `Sample client ${i + 1} notes`,
      lastContact: new Date(now.setDate(now.getDate() - i)).toISOString(),
      nextFollowUp: new Date(now.setDate(now.getDate() + 7)).toISOString(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }
  
  return sampleClients;
};
